const { VUE_APP_SITE_ID = '', DATA} = window.env
export const LS_WECHAT_USER_INFO_KEY = '$WECHAT_USER_INFO'
export const HISTORY_KEY = VUE_APP_SITE_ID + '_history'
export const ACCESS_KEY = VUE_APP_SITE_ID + '$ACCESS_CHECK_FAILED'
export const Log_Status = 'newLog_' + VUE_APP_SITE_ID
export const IMG_LOOP_INTERVAL = 150
export const LOG_LOOP_INTERVAL = 1500
export const LIST_LOG_LOOP_INTERVAL = LOG_LOOP_INTERVAL * 2
export const TICKET_DATABASE_NAME = VUE_APP_SITE_ID + 'TIKCET_DATA_BASE'
export const UAID = VUE_APP_SITE_ID ? 'UA-' + VUE_APP_SITE_ID : ''
export const ONLY_PID_STR = [DATA.poolId, null, null, null].join(',')
export const CHECK_UNIQUE_FORMID = '737109750218719232'